<template>
  <div>
    <div class="row mt-3">
      <!-- <div class="col-lg-4">
        <h4 class="pt-1">Service Request</h4>
        <hr>
        <div v-if="!selectedDate">
          <p>Please select a date.</p>
        </div>
        <div v-if="selectedDate">
          <p>{{ selectedDate.toDateString() }}</p>
          <label style="margin-bottom: 0; margin-top: 10px;">Start Time</label>
          <div class="input-group">
            <select class="form-control" v-model="startHour">
              <option v-for="(hour, index) in hourOptions" :key="'StartHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="startMinute">
              <option v-for="(minute, index) in minuteOptions" :key="'StartMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="startAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'StartAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <label style="margin-bottom: 0; margin-top: 10px;">End Time</label>
          <div class="input-group">
            <select class="form-control" v-model="endHour">
              <option v-for="(hour, index) in hourOptions" :key="'EndHour'+index">{{ hour }}</option>
            </select>
            <select class="form-control" v-model="endMinute">
              <option v-for="(minute, index) in minuteOptions" :key="'EndMinute'+index">{{ minute }}</option>
            </select>
            <select class="form-control" v-model="endAMPM">
              <option v-for="(ampm, index) in ampmOptions" :key="'EndAMPM'+index">{{ ampm }}</option>
            </select>
          </div>
          <hr>
          <button class="mylisting-button dark-button" @click="postJob()">Create Request</button>
        </div>
      </div> -->
      <div class="col-lg-12 calendar" style="min-height: 600px;">
        <calendar-view
          :show-date="showDate"
          class="theme-default holiday-us-traditional holiday-us-official"
          @click-date="onClickDate"
          :date-classes="selectedDateObj"
          :events="calendarJobs"
          @click-event="onClickEvent"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate"
          />
        </calendar-view>
      </div>
    </div>

    <table class="web-only table table-striped mt-3 mb-5">
      <thead class style="background-color: var(--nannycogreen); color: #fff;">
        <tr class>
          <th scope="col">Date</th>
          <th scope="col">Family</th>
          <th scope="col">Nanny</th>
          <th scope="col">Start Time</th>
          <th scope="col">End Time</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="job in jobs" :key="job.id" style="cursor: pointer">
          <td>{{ new Date(job.date).toDateString() }}</td>
          <td>{{ job.poster_name }}</td>
          <td>{{ job.filler_name }}</td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.start_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_start_time) }}</span>
            <!-- <span v-if="job.status == 'In Progress'">{{ djangotimeformatAMPM(job.actual_start_time) }}</span> -->
          </td>
          <td>
            <span v-if="job.status == 'Approved'">{{ djangotimeformatAMPM(job.end_time) }}</span>
            <span v-else>{{ djangotimeformatAMPM(job.actual_end_time) }}</span>
          </td>
          <td>{{ job.status }}</td>
          <td>
            <router-link
              :to="{ name: 'Job', params: { id: job.id } }"
              class="mylisting-button dark-button"
              target="_blank"
            >View Job Listing</router-link>
            <!-- <button v-if="job.status == 'Approved'" class="mylisting-button dark-button" @click="showClockInModal(job)">Clock In</button> -->
            <!-- <button v-if="job.status == 'In Progress'" class="mylisting-button dark-button" @click="showClockOutModal(job)">Clock Out</button> -->
          </td>
        </tr>
      </tbody>
    </table>

    <modal name="job-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- <h2>Status updated.</h2> -->
        <!-- {{ job }} -->
        <h4>{{ job.poster_name }} - {{ new Date(job.date).toDateString() }}</h4>
        <hr>
        <p>Start Time: {{ djangotimeformatAMPM(job.start_time) }}</p>
        <p>End Time: {{ djangotimeformatAMPM(job.end_time) }}</p>
        <pre v-if="job.text2">Preferred Nanny: {{ job.text2 }}</pre>
        <pre v-if="job.text">Special Notes: {{ job.text }}</pre>
        <hr>
        <h5>Filled By: {{ job.filler_name }}</h5>
        <p class="mb-1">Current Status: {{ job.status }}</p>
        <div class="input-group" style="max-width: 450px;">
          <select class="form-control" v-model="status">
            <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
          </select>
          <button class="btn btn-secondary" @click="updateStatus()">Update Status</button>
        </div>
        <div v-if="applications.length">
          <hr>
          <button class="btn btn-secondary" @click="refreshApplications()">Refresh</button>
          <!-- <p>{{ applications }}</p> -->
          <table class="table table-striped mt-2 shadow">
            <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
              <tr class="">
                <th scope="col">Name</th>
                <th scope="col">Broadcast Date</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="application in applications" :key="application.id" style="cursor: pointer;">
                <td>
                  {{ application.applicant_name }}
                </td>
                <td>
                  <p>{{ new Date(application.date).toDateString() }}</p>
                </td>
                <td>
                  {{ application.status }}
                  <!-- <button class="btn btn-danger" @click="deleteApplication(application)">Delete</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-modal')" style="">Close</button>
        <!-- <div style="margin-top: 20px; margin-bottom: 20px;"> -->
          <router-link
            :to="{ name: 'Job', params: { id: job.id } }"
            class="mylisting-button dark-button"
            target="_blank"
          >View Job Listing</router-link>
        <!-- </div> -->
        <!-- <button class="mylisting-button danger-button" @click="$modal.show('delete-job-modal')" style="float: right;">Delete</button> -->
        <button v-if="!applications.length" class="mylisting-button dark-button" @click="showBroadcastModal()" style="float: right;">Broadcast</button>
        <p @click="$modal.show('delete-job-modal')" style="color: red; cursor: pointer;" class="mt-3">Delete Request</p>

      </div>
    </modal>

    <modal name="status-updated-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Status updated.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('status-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-job-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Are you sure you want to delete this request?</h3>
        <!-- <p>{{ user.first_name }} {{ user.last_name }}</p> -->
        <!-- <p>{{ user.email }}</p> -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-job-modal')" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteJob()" style="float: right;">Delete</button>
      </div>
    </modal>

    <modal name="broadcast-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Please select which nannies you would like to broadcast this to</h2>
        <hr>
        <div v-for="(candidate, index) in candidates" :key="'Candidate'+index">
          <h5 @click="selectCandidate(candidate)" style="cursor: pointer;">{{ candidateEmails[index] }} <span v-if="selectedCandidates.includes(candidate)"><i style="font-size: 15px;" class="material-icons mt-1">check_circle</i></span></h5>
        </div>
        <!-- {{ selectedCandidates }} -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('broadcast-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" @click="broadcast()" style="float: right;">Broadcast</button>
      </div>
    </modal>

    <modal name="successfully-broadcasted-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Broadcast sent!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('successfully-broadcasted-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");

export default {
  // props: ['user'],
  components: {
    CalendarView,
    CalendarViewHeader
  },
  data () {
    return {
      showDate: new Date(),
      selectedDateObj: {},

      selectedDate: null,
      selectedFilterEmployer: "", //v-model to employer Email

      // startHour: 'HH',
      // startMinute: 'MM',
      // startHour: '01',
      startHour: 1,
      startMinute: '00',
      startAMPM: 'AM',
      startTime: null,
      // endHour: '01',
      endHour: 1,
      endMinute: '00',
      endTime: null,
      endAMPM: 'AM',

      // hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      // hourOptions: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      // hourOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      minuteOptions: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      ampmOptions: ['AM', 'PM'],

      // events: [{id: 0, startDate: '2020-04-5 09:00:00', title: 'Goel Family'}, {id: 1, startDate: '2020-04-12 09:00:00', title: 'Goel Family'}, {id: 2, startDate: '2020-04-19 09:00:00', title: 'Goel Family'}],

      jobs: [],
      calendarJobs: [],
      job: {},

      applications: [],

      status: '',
      statuses: [],

      candidates: [],
      candidateEmails: [],
      selectedCandidates: [],
    }
  },
  created() {
    this.getJobs()
    this.statuses = this.$store.getters.jobStatuses
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    onClickDate(d) {
      console.log('date clicked')
      console.log(d)
      this.selectedDate = d

      // this.currentStep = 1;
      // this.selectedStartDate = d;
      // // this.selectedStartDate = d.toISOString().substring(0, 10);
      // this.selectedDateObj = {
      //   [this.selectedStartDate]: "ClassForSelectedDate"
      // };
      // console.log("selected date", this.selectedDateObj);
    },
    onClickEvent(event) {
      console.log(event)
      axios.get(`/api/jobs/?id=${event.id}`)
        .then(res => {
          console.log(res)
          this.job = res.data[0]
          this.status = this.job.status

          this.getApplications(this.job)
          // axios.get(`/api/jobapplications/?job=${this.job.id}`)
          //   .then(res => {
          //     console.log(res)
          //     this.applications = res.data

          //     this.$modal.show('job-modal')
          //   })
          //   .catch(error => console.log(error))
          this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
    getJobs() {
      axios.get(`/api/jobs/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          console.log(res)
          this.jobs = res.data
          this.jobs = this.jobs.sort((a, b) => (a.date < b.date) ? 1 : -1)

          this.calendarJobs = []
          for (var job in this.jobs) {
            console.log('dsgjaklsjl;kds')
            // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
            this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getApplications(job) {
      axios.get(`/api/jobapplications/?job=${job.id}`)
        .then(res => {
          console.log(res)
          this.applications = res.data

          // this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
    refreshApplications() {
      this.getApplications(this.job)
    },
    postJob() {
      console.log('Posting job')

      if (this.startHour == 12) {
        this.startHour -= 12
      }
      // else {
      //   this.startHour -= 1
      // }
      if (this.startAMPM == 'PM') {
        this.startHour += 12
      }
      this.startHour = ("0" + this.startHour).slice(-2);

      if (this.endHour == 12) {
        this.endHour -= 12
      }
      // else {
      //   this.endHour -= 1
      // }
      if (this.endAMPM == 'PM') {
        this.endHour += 12
      }
      this.endHour = ("0" + this.endHour).slice(-2);

      // this.events.push({id: 4, startDate: this.selectedDate, title: 'Enginehire Family'})
      axios.post('/api/jobs/', {
        poster: this.user.id,
        poster_name: this.user.employer_name,
        date: this.dateInDjangoFormat(this.selectedDate),
        // start_time: this.convertTimeFormat(`${this.startHour}:${this.startMinute}${this.startAMPM}`),
        // end_time: this.convertTimeFormat(`${this.endHour}:${this.endMinute}${this.endAMPM}`),
        start_time: `${this.startHour}:${this.startMinute}:00`,
        end_time: `${this.endHour}:${this.endMinute}:00`,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.getJobs()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteJob() {
      axios.delete(`/api/jobs/${this.job.id}`)
        .then(res => {
          console.log(res)
          this.getJobs()
          this.$modal.hide('job-modal')
          this.$modal.hide('delete-job-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteApplication(application) {
      axios.delete(`/api/jobapplications/${application.id}`)
        .then(res => {
          console.log(res)
          this.getApplications(this.job)
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateStatus() {
      axios.patch(`/api/jobs/${this.job.id}/`, {
        status: this.status
      })
        .then(res => {
          console.log(res)
          this.job.status = this.status
          this.getJobs()
          this.$modal.show('status-updated-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showBroadcastModal() {
      this.getCandidates()
      this.$modal.show('broadcast-modal')
    },
    getCandidates() {
      axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=${this.$store.getters.activeStatus}`)
        .then(res => {
          this.candidates = res.data;
          console.log("Candidates", this.candidates);
          this.candidateEmails = this.candidates.map(
            candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
          );
        })
        .catch(error => console.log(error));
    },
    selectCandidate(candidate) {
      //
      // What happens when clicking on a candidate in the list of candidates
      //
      if (!this.selectedCandidates.includes(candidate)) { // If we haven't already selected a time, select it
        this.selectedCandidates.push(candidate)
      }
      else {
        this.selectedCandidates.splice(this.selectedCandidates.indexOf(candidate), 1)
      }
    },
    broadcast() {
      // Send out the notification
      for (var candidate in this.selectedCandidates) {
        console.log(this.selectedCandidates[candidate])
        axios.post(`/api/jobapplications/`, {
          applicant: this.selectedCandidates[candidate].id,
          applicant_name: `${this.selectedCandidates[candidate].first_name} ${this.selectedCandidates[candidate].last_name}`,
          job: this.job.id,
          job_title: this.job.poster_name,
          status: 'No Response',
          agency_owner: this.$store.getters.agencyName,
          agency: this.$store.getters.agencyID,
        })
          .then(res => {
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
            let selectedCandidate = this.selectedCandidates.filter(user => user.id == res.data.applicant)[0]
            console.log(selectedCandidate)

            // if (this.selectedCandidates[candidate].preferences3.includes('Email')) { // If the candidate wants to be notified via email
            if (selectedCandidate.preferences3.includes('Email')) { // If the candidate wants to be notified via email
              this.$store.dispatch('sendEmail',
                {
                  subject: `New Opportunity ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}, ${this.djangotimeformatAMPM(this.job.start_time)} - ${this.djangotimeformatAMPM(this.job.end_time)}`,
                  // message: 'Hello ' + this.selectedCandidates[candidate].first_name + ',\n\n' +
                  message: 'Hello ' + selectedCandidate.first_name + ',\n\n' +
                  'A family has posted a request for a nanny that you might be interested in!\n' +
                  // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
                  `To see all the details please go to https://goldcoastnannies.enginehire.io/job/${this.job.id} \n\n` +
                  `Date: ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}\n` +
                  `Start Time: ${this.djangotimeformatAMPM(this.job.start_time)}\n` +
                  `End Time: ${this.djangotimeformatAMPM(this.job.end_time)}\n\n` +
                  'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' +
                  'Thanks!\n'+
                  'The Nanny Company Team',
                  from: this.$store.getters.agencyFromEmail,
                  // email: this.selectedCandidates[candidate].email,
                  email: selectedCandidate.email,
                  reply: this.$store.getters.agencyReplyEmail,
                  // userID: this.aakashid,
                  // userID: this.selectedCandidates[candidate].id,
                  userID: selectedCandidate.id,
                }
              )
            }

            // Increment the counter for the number of broadcasts this candidate has received
            // let statsArray = this.selectedCandidates[candidate].numberArray
            let statsArray = selectedCandidate.numberArray
            // console.log(statsArray)
            statsArray[0] += 1
            // console.log(statsArray)
            // axios.patch(`/api/people/${this.selectedCandidates[candidate].id}/`, {
            axios.patch(`/api/people/${selectedCandidate.id}/`, {
              numberArray: statsArray
            })
              .catch(error => console.log(error))

            if (candidate == (this.selectedCandidates.length - 1)) { // If we just processed the last candidate in the list
              this.getApplications(this.job)
              this.$modal.show('successfully-broadcasted-modal')
              this.$modal.hide('broadcast-modal')

              axios.patch(`/api/jobs/${this.job.id}/`, {
                status: 'Pending',
              })
                .then(res => {
                  console.log(res)
                  this.job.status = 'Pending'
                  this.status = 'Pending'
                })
                .catch(error => console.log(error))
            }
          })
          .catch(error => console.log(error))
      }
      // this.$modal.show('successfully-broadcasted-modal')
      // this.$modal.hide('broadcast-modal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/MasterCalendar.vue